// import React from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useState } from "react";
// import API_BASE_URL from "../config";

// const globalFontStyle={
//   fontFami:"Arial, sans-serif"
// }
// const containerStyle = {
//   ...globalFontStyle,
//   width: "85%",
//   maxWidth: "3000px", // Prevents excessive stretching
//   marginLeft: "20rem",
//   padding: "20px",
//   border: "1px solid #ccc",
//   borderRadius: "8px",
//   backgroundColor: "#f9f9f9",
//   boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
// };
// const heading = {
//   ...globalFontStyle,
//   textAlign: "center",
//   backgroundColor: "#000", // Black background
//   color: "#fff", // White text
//   padding: "15px 20px",
//   borderRadius: "8px",
//   boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
//   width: "fit-content",
//   margin: "2rem 2rem 2rem 22rem",
//   fontSize: "1.8rem",
//   fontWeight: "bold",
//   textTransform: "uppercase",
//   letterSpacing: "1px",
// };


// const formStyle = {
//   ...globalFontStyle,
//   display: "grid",
//   gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", // Responsive grid,
//   gridAutoRows: "auto", // Allows flexible row height
//   gap: "40px",
//   paddingRight: "20px 20px",
//   marginRight: "20px",
// };

// const labelStyle = { fontWeight: "bold", marginBottom: "5px"  };
// const inputStyle = {
//   width: "100%",
//   padding: "6px",
//   border: "1px solid #ccc",
//   borderRadius: "4px",
// };

// const buttonContainerStyle = {
//   display: "flex",
//   justifyContent: "space-between",
//   marginTop: "20px",
//   marginLeft:"20rem",
//   gap:"2rem"
// };

// const buttonStyle = {
//   padding: "10px 15px",
//   border: "none",
//   borderRadius: "5px",
//   cursor: "pointer",
//   color: "white",
//   width: "15rem",
//   height: "2.5rem",
//   backgroundColor:"black"
// };


// const DriverConfirmation = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const formData = location.state?.formData || {};
//   const [loading, setLoading] = useState(false);

//   const handleConfirm = async () => {
//     if (Object.keys(formData).length === 0) {
//       alert("No driver data available to submit.");
//       return;
//     }
//     setLoading(true);
//     console.log("data in confirm", JSON.stringify(formData));
//     try {
//       const response = await fetch(
//         API_BASE_URL + "/onboarding/driver-confirm",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(formData),
//         }
//       );

      
//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//     }
      
//       const data = await response.json();
//       console.log("Success:", data);

//       if (response.ok) {
//         alert("Driver details confirmed and saved successfully!");
//       } else {
//         alert("Failed to save driver details. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error saving data:", error);
//       alert("Error: " + (error?.response?.data?.message || error.message || "An error occurred while saving. Please try again."));
//     }
//     finally{
//       setLoading(false);
//     }
//   };

//   return (
//     <div>
//        <h2 style={heading}>Driver Onboarding</h2>
//     <div style={containerStyle}>
//       <form style={formStyle}>
//         {Object.entries(formData).map(([key, value]) => (
//           <div key={key}>
//             <label style={labelStyle}>
//             {key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())}
//             </label>

//             <input type="text" value={value} readOnly style={inputStyle} />
//           </div>
//         ))}
//       </form>
//       <div style={buttonContainerStyle}>
//         <button style={buttonStyle} onClick={() => navigate(-1)} disabled={loading}>
//           Edit
//         </button>
//         <button style={buttonStyle} onClick={handleConfirm} disabled={loading}>
//           {loading ? "Confirming..." : "Confirm"}
//         </button>
//       </div>
//     </div>
//     </div>
//   );
// };

// export default DriverConfirmation;
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import API_BASE_URL from "../config";

const DriverConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const formData = location.state?.formData || {};
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (Object.keys(formData).length === 0) {
      alert("No driver data available to submit.");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(API_BASE_URL + "/onboarding/driver-confirm", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      console.log("Success:", data);
      alert("Driver details confirmed and saved successfully!");
    } catch (error) {
      console.error("Error saving data:", error);
      alert("Error: " + (error?.response?.data?.message || error.message || "An error occurred while saving. Please try again."));
    } finally {
      setLoading(false);
    }
  };

  const s = {
    container: {
      fontFamily: "Arial, sans-serif",
      marginLeft: "278px",
      marginRight: "10px",
      backgroundColor: "#ffffff",
      color: "#000000",
      minHeight: "100vh",
    },
    pageHeader: {
      backgroundColor: "#FFC107",
      padding: "16px 24px",
      marginBottom: "0px",
    },
    pageHeaderText: {
      fontSize: "22px",
      fontWeight: "700",
      color: "#000000",
      letterSpacing: "1px",
      textTransform: "uppercase",
      margin: 0,
    },
    contentBody: {
      padding: "24px",
    },
    sectionTitle: {
      fontSize: "15px",
      fontWeight: "700",
      color: "#000000",
      marginBottom: "4px",
    },
    sectionDivider: {
      border: "none",
      borderTop: "2px solid #FFC107",
      marginBottom: "16px",
    },
    formGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: "16px",
      marginBottom: "24px",
    },
    fieldGroup: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
    },
    label: {
      fontSize: "13px",
      fontWeight: "700",
      color: "#000000",
    },
    input: {
      width: "100%",
      padding: "8px 10px",
      border: "1.5px solid #000000",
      borderRadius: "0",
      fontSize: "13px",
      backgroundColor: "#f5f5f5",
      color: "#000000",
      outline: "none",
      boxSizing: "border-box",
      cursor: "not-allowed",
    },
    buttonRow: {
      display: "flex",
      gap: "12px",
      marginTop: "8px",
    },
    editButton: {
      padding: "8px 28px",
      backgroundColor: "#000000",
      color: "#ffffff",
      border: "none",
      borderRadius: "0",
      cursor: "pointer",
      fontWeight: "700",
      fontSize: "13px",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    confirmButton: {
      padding: "8px 28px",
      backgroundColor: "#FFC107",
      color: "#000000",
      border: "none",
      borderRadius: "0",
      cursor: loading ? "not-allowed" : "pointer",
      fontWeight: "700",
      fontSize: "13px",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      opacity: loading ? 0.7 : 1,
    },
  };

  return (
    <div style={s.container}>
      {/* Yellow header bar */}
      <div style={s.pageHeader}>
        <h1 style={s.pageHeaderText}>Driver Onboarding — Confirmation</h1>
      </div>

      <div style={s.contentBody}>
        <div style={s.sectionTitle}>Driver Details</div>
        <hr style={s.sectionDivider} />

        <div style={s.formGrid}>
          {Object.entries(formData).map(([key, value]) => (
            <div key={key} style={s.fieldGroup}>
              <label style={s.label}>
                {key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())}
              </label>
              <input
                type="text"
                value={value}
                readOnly
                style={s.input}
              />
            </div>
          ))}
        </div>

        <div style={s.buttonRow}>
          <button style={s.editButton} onClick={() => navigate(-1)} disabled={loading}>
            Edit
          </button>
          <button style={s.confirmButton} onClick={handleConfirm} disabled={loading}>
            {loading ? "Confirming..." : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DriverConfirmation;